import { MessageSquare } from "lucide-react";

const WHATSAPP_NUMBER = "50237792267";
const WHATSAPP_MSG = encodeURIComponent("Hola, me interesa cotizar productos promocionales con PYM.");

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      data-testid="whatsapp-float-btn"
      aria-label="Chat por WhatsApp"
    >
      <MessageSquare className="w-6 h-6" />
    </a>
  );
}
